import "./AdminPatientsSession.scss";
import { BackArrow } from "../../../assets/icons-components/Icons";
import CustomTooltip from "../../../components/CustomTooltip/CustomTooltip";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import RefreshIcon from "@mui/icons-material/Refresh";
import DateButton from "../../../components/DateButton/DateButton";
import Buttons from "../../../components/Buttons/Buttons";
import useAdminPatientsSession, {
  formatDate,
  formatDateOnly,
  formatSecondsToHMS,
} from "./useAdminPatientsSession";
import HighlightedPickersDay from "../../../components/HighlightedPickersDay/HighlightedPickersDay";
import SessionTable from "./SessionTable";
import ReferenceDataModal from "../../HealthCare/PatientSessionDetails/ReferenceDataModal";
import DownloadOptionsModal from "../../../components/DownloadOptionsModal/DownloadOptionsModal";
import ProcessingPopup from "../../../components/ProcessingPopup/ProcessingPopup";

const AdminPatientsSession = () => {
  const {
    page,
    rowsPerPage,
    rows,
    totalRows,
    isLoading,
    fetchError,
    calendarOpen,
    referenceModal,
    referenceData,
    downloadOptionsOpen,
    downloadOptionsRow,
    isDownloadingCsv,
    isDownloadingProcessedCsv,
    downloadProgress,
    downloadPopupOpen,
    downloadPopupTitle,
    downloadPopupLoading,
    selectedDate,
    highlightedDates,
    setCalendarOpen,
    setReferenceModal,
    setDownloadOptionsOpen,
    handleDateChange,
    handleChangePage,
    handleChangeRowsPerPage,
    handleDelete,
    handleView,
    handleTable,
    handleMainTableView,
    handleDownload,
    handleRefresh,
    handleMainTableDownload,
    handleDownloadCSVUrl,
    handleDownloadProcessedCSVUrl,
    handleCloseProcessingPopup,
  } = useAdminPatientsSession();

  return (
    <div className="admin-patients-session">
      <div className="admin-patients-session_headers">
        <div className="admin-patients-session_headers_left">
          <div className="admin-patients-session_headers_left_arrow">
            <Buttons
              icon={<BackArrow />}
              ariaLabel="Back to Patients"
              onClick={handleTable}
              style={{ border: "none", padding: 0, backgroundColor: "transparent", marginTop: 5 }}
            />
            <h3>Patients</h3>
            <CustomTooltip title="Refresh">
              <span>
                <Buttons icon={<RefreshIcon />} ariaLabel="Refresh" onClick={handleRefresh} />
              </span>
            </CustomTooltip>
          </div>
        </div>
        <div className="admin-patients-session_headers_right">
          <div className="admin-patients-session_headers_right_calendar">
            <DatePicker
              open={calendarOpen}
              onOpen={() => setCalendarOpen(true)}
              onClose={() => setCalendarOpen(false)}
              value={selectedDate}
              onChange={(date) => handleDateChange(date ? [date] : [])}
              views={["year", "month", "day"]}
              slots={{ field: DateButton, day: HighlightedPickersDay }}
              slotProps={{
                field: { value: selectedDate, onClick: () => setCalendarOpen(true) },
                day: { highlightedDates },
              }}
            />
          </div>
        </div>
      </div>

      <SessionTable
        rows={rows}
        page={page}
        rowsPerPage={rowsPerPage}
        totalRows={totalRows}
        formatDate={formatDate}
        formatDateOnly={formatDateOnly}
        formatSecondsToHMS={formatSecondsToHMS}
        onView={handleMainTableView}
        onDownload={handleMainTableDownload}
        onDelete={handleDelete}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        isLoading={isLoading}
        fetchError={fetchError}
        onRetry={handleRefresh}
      />

      {referenceModal && (
        <ReferenceDataModal
          referenceData={referenceData}
          formatDate={formatDate}
          formatDateOnly={formatDateOnly}
          onView={handleView}
          onDownload={handleDownload}
          onClose={() => setReferenceModal(false)}
          requireCsvUrl
        />
      )}

      {downloadOptionsOpen && downloadOptionsRow && (
        <DownloadOptionsModal
          row={downloadOptionsRow}
          onDownloadCsv={handleDownloadCSVUrl}
          onDownloadProcessedCsv={handleDownloadProcessedCSVUrl}
          onCancel={() => setDownloadOptionsOpen(false)}
          isDownloadingCsv={isDownloadingCsv}
          isDownloadingProcessedCsv={isDownloadingProcessedCsv}
          downloadProgress={downloadProgress}
        />
      )}

      {downloadPopupOpen && (
        <ProcessingPopup
          title={downloadPopupTitle}
          loading={downloadPopupLoading}
          progress={downloadProgress}
          onClose={handleCloseProcessingPopup}
        />
      )}
    </div>
  );
};

export default AdminPatientsSession;
